module.exports = __webpack_public_path__ + "img/huananligong.ac53699d.png";